import { render, staticRenderFns } from "./UpdateHistoryInfo.vue?vue&type=template&id=a6a6e1ec&scoped=true&"
import script from "./UpdateHistoryInfo.vue?vue&type=script&lang=ts&"
export * from "./UpdateHistoryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateHistoryInfo.vue?vue&type=style&index=0&id=a6a6e1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a6e1ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
